<div class="tax-steps">
  <span class="step" [ngClass]="{'fill' : category >= 1 }"></span>
  <span class="step" [ngClass]="{'fill' : category >= 2 }"></span>
  <span class="step" [ngClass]="{'fill' : category == 3 }"></span>
</div>
